import React from 'react';

const NotFound = () => {
    return (
         <div className='h-screen flex justify-center items-center'>
           <img className='w-2/3' src={require('../../images/2704133.jpg')} alt=""/>
        </div>
    );
};

export default NotFound;